/* eslint-disable react/prop-types */
import classNames from "classnames";

const Timeline = ({ reset, viewMode, toggleViewMode }) => {
  const isCurated = viewMode === "curated";

  return (
    <div className="flex items-center gap-3 flex-none">
      <h1
        onClick={reset}
        className="text-clouds-950 dark:text-midnight-200 hover:text-accent-500 dark:hover:text-accent-600 font-bold italic text-3xl cursor-pointer"
      >
        TIMELINE
      </h1>

      <button
        type="button"
        onClick={toggleViewMode}
        aria-pressed={isCurated}
        aria-label={isCurated ? "view full timeline" : "view curated selection"}
        className={classNames(
          "group relative w-[26px] h-[26px] rounded-full flex-none cursor-pointer animate-spin-slow",
          "border-2 transition-[border-color,box-shadow] duration-500",
          isCurated
            ? "border-[#5fdb7e] shadow-[0_0_0_3px_rgba(95,219,126,0.18)]"
            : "border-[#AC1CFF]",
        )}
      >
        <span
          className={classNames(
            "absolute inset-0 flex items-center justify-center text-[10px] font-bold leading-none text-[#AC1CFF] transition-[opacity,transform] duration-300",
            isCurated
              ? "opacity-100 scale-100 group-hover:opacity-0 group-hover:scale-90"
              : "opacity-100 scale-100",
          )}
        >
          c
        </span>
        <span
          className={classNames(
            "absolute inset-0 flex items-center justify-center text-xs leading-none text-[#AC1CFF] transition-[opacity,transform] duration-300",
            isCurated
              ? "opacity-0 scale-90 group-hover:opacity-100 group-hover:scale-100"
              : "opacity-0 scale-90",
          )}
        >
          ←
        </span>
      </button>
    </div>
  );
};

export { Timeline };
